if (!customElements.get('gms-feature-tour')) {
  customElements.define('gms-feature-tour', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      this.panels = [...this.querySelectorAll('[role="tabpanel"]')];
      this.selectedIndex = Math.max(0, this.tabs.findIndex(tab => tab.getAttribute('aria-selected') === 'true'));
      this.stage = this.querySelector('[data-gms-gallery-stage]');
      this.counter = this.querySelector('[data-gms-gallery-current]');
      this.thumbnailStrip = this.querySelector('.gms-gallery-thumbnails');
      this.querySelectorAll('[data-gms-gallery-step]').forEach(button => {
        button.addEventListener('click', () => this.select(this.selectedIndex + Number(button.dataset.gmsGalleryStep)));
      });
      if (this.stage) {
        this.stage.addEventListener('pointerdown', event => {
          this.swipeStart = null;
          if (event.pointerType === 'mouse' || event.target.closest('button,video,a,.gms-gallery-panel--film')) return;
          this.swipeStart = { x: event.clientX, y: event.clientY, id: event.pointerId };
        });
        this.stage.addEventListener('pointerup', event => {
          const start = this.swipeStart;
          this.swipeStart = null;
          if (!start || start.id !== event.pointerId) return;
          const dx = event.clientX - start.x;
          const dy = event.clientY - start.y;
          if (Math.abs(dx) >= 45 && Math.abs(dx) > Math.abs(dy) * 1.4) this.select(this.selectedIndex + (dx < 0 ? 1 : -1));
        });
        this.stage.addEventListener('pointercancel', () => { this.swipeStart = null; });
      }
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.select(index));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.tabs.length - 1;
          if (next !== undefined) { event.preventDefault(); this.select(next); this.tabs[next].focus(); }
        });
      });
    }
    select(index) {
      if (!this.tabs.length) return;
      index = ((index % this.tabs.length) + this.tabs.length) % this.tabs.length;
      this.selectedIndex = index;
      if (this.counter) this.counter.textContent = String(index + 1);
      if (this.thumbnailStrip) {
        const strip = this.thumbnailStrip;
        const frame = strip.getBoundingClientRect();
        const item = this.tabs[index].getBoundingClientRect();
        if (item.right > frame.right - 3) strip.scrollLeft += item.right - frame.right + 3;
        else if (item.left < frame.left + 3) strip.scrollLeft += item.left - frame.left - 3;
      }
      this.tabs.forEach((tab, i) => { tab.setAttribute('aria-selected', String(i === index)); tab.tabIndex = i === index ? 0 : -1; });
      this.panels.forEach((panel, i) => { panel.hidden = i !== index; if (i !== index) panel.querySelectorAll('audio,video').forEach(media => media.pause()); });
    }
  });
}
